import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, BoxProps } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import { StyledGoBackLink } from './styles'

export const GoBackLink = ({ ...boxProps }: BoxProps): JSX.Element => {
  const { t } = useTranslation('common')
  const router = useRouter()

  return (
    <Box onClick={() => router.back()} {...boxProps}>
      <StyledGoBackLink>
        <img src="/icons/arrow-left.svg" alt="" />
        {t('goBack')}
      </StyledGoBackLink>
    </Box>
  )
}
